<template>
  <div>
    <el-dialog
      :title="$t('receivablePayable.examine')"
      :visible.sync="showExamine"
      width="600px"
    >
      <el-form
        :key="showExamine" ref="examineForm" :model="examineForm"
        label-width="auto"
      >
        <!--审核-->
        <el-form-item
          :label="$t('receivablePayable.examine')"
          prop="examine"
          :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
        >
          <el-radio-group v-model="examineForm.examine">
            <div style="margin-bottom: 5px;">
              <!--通过（多条数据合并生成一个收款单）-->
              <el-radio :label="0">{{ $t('receivablePayable.PassMultipleDataMergingToGenerateOneReceipt') }}</el-radio>
            </div>
            <div style="margin-bottom: 5px;">
              <!--通过（多条数据生成多个收款单）-->
              <el-radio :label="1">{{ $t('receivablePayable.GenerateMultipleReceiptsThrough') }}</el-radio>
            </div>
            <div>
              <!--不通过-->
              <el-radio :label="2">{{ $t('receivablePayable.DoesNotPass') }}</el-radio>
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="$t('receivablePayable.remark')"
          prop="remark"
          :rules="{ required: examineForm.examine === 2, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
        >
          <el-input v-model="examineForm.remark" type="textarea" :rows="6" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="examine(1)">{{ $t('basicData.Cancel') }}</el-button>
        <el-button type="primary" @click="examine(2)">{{ $t('basicData.determine') }}</el-button>
      </span>
    </el-dialog>

    <!-- 显示审核结果弹窗 -->
    <PaymentDialog
      ref="paymentDialog"
      @change="close"
    />
  </div>
</template>

<script>
import { apiPayableTransportBillAudit, apiPayableSiteBillAudit } from '@/api/finance/receivables';

export default {
  name: 'ReviewDialog',

  components: {
    PaymentDialog: () => import('./paymentDialog.vue')
  },

  props: {
    // 勾选数据
    data: {
      type: Array,
      default: () => []
    },
    // 1 快递账单 2 干支线账单
    type: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      showExamine: false,
      examineForm: {
        examine: 0,
        remark: ''
      }
    };
  },

  methods: {
    open() {
      this.showExamine = true;
    },

    /**
     * 审核
     * @param type 1 取消 2 保存
     */
    examine(type) {
      if (type === 2) {
        const ids = [];
        const businessTypes = [];
        const providerList = [];
        this.data.map(item => {
          if (businessTypes.includes(item.businessType) === false) {
            businessTypes.push(item.businessType);
          }
          if (providerList.includes(item.providerId) === false) {
            providerList.push(item.providerId);
          }
          ids.push(item.billBatchNumber);
        });
        if (this.examineForm.examine === 0) {
          // 快递审核需要校验业务类型是否唯一
          if (businessTypes.length > 1 && this.type === 1) {
            this.$message.warning(this.$t('receivablePayable.OnlyDataSameServiceTypeCanSelected'));
            return;
          }
          // 干支线审核校验主体是否唯一
          if (providerList.length > 1 && this.type === 2) {
            this.$message.warning(this.$t('receivablePayable.onlySelectSameSubjectData'));
            return;
          }
        }
        const param = {
          billBatchNumbers: ids,
          operationType: this.examineForm.examine,
          auditReason: this.examineForm.remark
        };
        const API = this.type === 1 ? apiPayableSiteBillAudit : apiPayableTransportBillAudit;
        this.$refs['examineForm'].validate((valid) => {
          if (valid) {
            API(param).then(res => {
              const { code, data } = res;
              if (code === 200) {
                console.log(res, '审核结果');
                this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
                if (data.length) {
                  this.$refs.paymentDialog.open(data);
                }
                this.cancelLog();
                this.$emit('change');
              }
            }).catch(err => {
              console.error(err);
            });
          }
        });
      } else {
        this.cancelLog();
      }
    },
    close() {
      this.cancelLog();
      this.$emit('change');
    },
    cancelLog() {
      this.showExamine = false;
      this.examineForm.examine = 2;
      this.examineForm.remark = '';
    }
  }
};
</script>

<style scoped lang="scss">
</style>
